<template>
    <div class="component-upload-image">
      <el-upload
        multiple
        :action="uploadImgUrl"
        list-type="picture-card"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :limit="limit"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        ref="imageUpload"
        :on-remove="handleDelete"
        :show-file-list="true"
        :headers="headers"
        :file-list="fileList"
        :on-preview="handlePictureCardPreview"
        :class="{hide: this.fileList.length >= this.limit}"
        :data="uploadData"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
  
      <!-- 上传提示 -->
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        请上传
        <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
        <!-- <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template> -->
        <template v-if="fileType"> 格式为 <b style="color: #f56c6c">"mp4"</b> </template>
        的文件
      </div>
  
      <el-dialog
        :visible.sync="dialogVisible"
        title="预览"
        width="800"
        append-to-body
      >
       

        <audio
      style="
        width: 100%;
        height: 100px;
        padding: 30px;
        margin-top: 10px;
      "
      v-if="isVideo"
      controls
      :src="previewUrl"
    ></audio>
    <video
      style=" margin-top: -20px"
      v-if="isAudio"
      width="100%"
      height="100%"
      controls
      :src="previewUrl"
    ></video>
    <iframe
      v-if="isExcel"
      :src="excelPreviewUrl"
      frameborder="0"
      width="100%"
      height="600"
    >
    </iframe>
 
    <div
      style="
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      v-if="isImage"
    >
      <img
        class="previewImg"
        :src="previewUrl"
        alt=""
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { getToken } from "@/utils/auth";
  import { getappends } from "@/api/system/dict/data";

  import{getVideoCover} from "@/utils/index";
  
  export default {
    props: {
      value: [String, Object, Array],
      // 图片数量限制
      limit: {
        type: Number,
        default: 5,
      },
      // 大小限制(MB)
      fileSize: {
         type: Number,
        default: 500,
      },
      // 文件类型, 例如['png', 'jpg', 'jpeg']
      fileType: {
        type: Array,
        default: () => ["png", "jpg", "jpeg","mp4"],
       
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        number: 0,
        uploadList: [],
        dialogVisible: false,
        hideUpload: false,
        // uploadImgUrl: process.env.VUE_APP_BASE_API + "/file/upload", // 上传的图片服务器地址
        uploadImgUrl: process.env.VUE_APP_BASE_API + "/file/uploadtwo", // 上传的图片服务器地址
        headers: {
          Authorization: "Bearer " + getToken(),
        },
        fileList: [],
        uploadData:{
          path:""
        },

        isAudio: false, //视频
  isVideo: false, //音频
  isImage: false, //照片
  isExcel: false, //文件
  excelPreviewUrl: "", //文件地址
  previewUrl: "", //视频、音频、照片、文件地址
      };
    },
    watch: {
      value: {
        handler ( val ) {
          if (val) {
            // 首先将值转为数组
            // const list = Array.isArray(val) ? val : this.value.split(',');
            this.fileList=[]
            const list =  this.realSrcList();
            return;
            // 然后将数组转为对象数组
            this.fileList = list.map(item => {
              if (typeof item === "string") {
                item = { name: item, url: item };
              }
              return item;
            });
          } else {
            this.fileList = [];
            return [];
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      // 是否显示提示
      showTip() {
        return this.isShowTip && (this.fileType || this.fileSize);
        // return this.isShowTip && ("mp4" || this.fileSize);
      },
    },
    methods: {
      // 上传前loading加载
      handleBeforeUpload(file) {
        let isImg = false;
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some(type => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }
  
        if (!isImg) {
          this.$modal.msgError(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
          return false;
        }
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$modal.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
            return false;
          }
        }
        this.$modal.loading("正在上传，请稍候...");
        this.number++;
      },
      // 文件个数超出
      handleExceed() {
        this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
      },
      // 上传成功回调
      handleUploadSuccess(res, file) {
        if (res.code === 200) {
          this.uploadList.push({ name: res.data.url, url: res.data.url,id:res.data.appendId });
          this.uploadedSuccessfully();
        } else {
          this.number--;
          this.$modal.closeLoading();
          this.$modal.msgError(res.msg);
          this.$refs.imageUpload.handleRemove(file);
          this.uploadedSuccessfully();
        }
      },
      // 删除图片
      handleDelete(file) {
        const findex = this.fileList.map(f => f.name).indexOf(file.name);
        if (findex > -1) {
          this.fileList.splice(findex, 1);
          // this.$emit("input", this.listToString(this.fileList));
          
          // this.$emit("update:modelValue", this.fileList);
          // this.$emit("update:appid",this.listToString(this.fileList) );
          this.$emit("imagedata",this.listToString(this.fileList) );
  
        }
      },
      // 上传失败
      handleUploadError() {
        this.$modal.msgError("上传失败，请重试");
        this.$modal.closeLoading();
      },
      // 上传结束处理
      uploadedSuccessfully() {
        if (this.number > 0 && this.uploadList.length === this.number) {
          this.fileList = this.fileList.concat(this.uploadList);
          this.uploadList = [];
          this.number = 0;
          // this.$emit("input", this.listToString(this.fileList));
          // this.$emit("update:modelValue", this.fileList);
          // this.$emit("update:appid",this.listToString(this.fileList) );
          this.$emit("imagedata",this.listToString(this.fileList) );
  
          this.$modal.closeLoading();
        }
      },
  
 
      // 预览会传把这一行的文件名拿到 然后取到后缀名，根据后缀名进行判断
      handlePictureCardPreview(val) {
      this.dialogVisible = true;
      if (val.type == "radio") {
        this.previewUrl = val.realurl;
        this.isVideo = true;
        this.isAudio = false;
        this.isExcel = false;
        this.isImage = false;
      } else if (val.type == "video") {
        this.previewUrl = val.realurl;
        this.isAudio = true;
        this.isVideo = false;
        this.isExcel = false;
        this.isImage = false;
      } else if (val.type == "xlsx" || val.fileExtension == "xls") {
        const encodedFileUrl = encodeURIComponent(val.url); // 对文件URL进行编码
        this.excelPreviewUrl = `https://view.officeapps.live.com/op/view.aspx?    
        src=${encodedFileUrl}`;
        // 显示预览
        this.isAudio = false;
        this.isVideo = false;
        this.isExcel = true;
        this.isImage = false;
      } else {
        this.previewUrl = val.realurl;
        // 显示预览
        this.isAudio = false;
        this.isVideo = false;
        this.isExcel = false;
        this.isImage = true;
      }
    },
                        
      // 对象转成指定字符串分隔
      listToString(list, separator) {
        let strs = "";
        separator = separator || ",";
        for (let i in list) {
          if (list[i].id) {
            strs += (list[i].id+"").replace(this.baseUrl, "") + separator;
          }
        }
        return strs != '' ? strs.substr(0, strs.length - 1) : '';
      },
  
      // 通过附件的ID，获取附件的详细信息
      getapp(item) {
         
         var that =this;
         return new Promise((resolve, reject) => {
              
               getappends(item).then((res) => {
              that.srcList.push(res.data.url);
         });
               resolve()
    
       })
       },
  
      realSrcList() {
        var that =this;
        if (!this.value||this.value.length==0) {
          return;
        }
        var real_src_list = this.value.split(",") || [];
     
  // Promise.all(
  
  // if ( Array.isArray(real_src_list) ) {
  
  // }
        
    real_src_list.forEach(async (item)=> {
      if (item.length&&item.length>17) {
        return;
      }
      console.log(item,"打印出来附件ID");
      
          return new Promise(async (resolve, reject) => {
            if (item.length&&item.length<17) {
              
              await       new Promise((resolve, reject) => {
              
              getappends(item).then( async( res) => {

            getVideoCover(res.data,that.fileList);
        });
              resolve()
   
      })
            }
           
              resolve(
           
              )
   
          })
      })
  
   
  // ).then(() => {
      
  //     return srcList;
  // })
  
      },

   
    },
    mounted(){
  
  
  console.log("imageupload-mounted");
  if (this.$route.fullPath) {
    this.uploadData.path=this.$route.fullPath
  } else if( this.$route.path) {
    this.uploadData.path=this.$route.path
  
  }
  
  
    }
  };
  </script>
  <style scoped lang="scss">
  // .el-upload--picture-card 控制加号部分
  ::v-deep.hide .el-upload--picture-card {
      display: none;
  }
  // 去掉动画效果
  ::v-deep .el-list-enter-active,
  ::v-deep .el-list-leave-active {
      transition: all 0s;
  }
  
  ::v-deep .el-list-enter, .el-list-leave-active {
    opacity: 0;
    transform: translateY(0);
  }
  </style>
  
  